document.addEventListener('DOMContentLoaded', function () {
  let buttons = document.querySelectorAll('.js-menu-restaurant');
  buttons.forEach((button) => {
    let link = button.querySelector('a');
    let section = null;
    if (link.getAttribute('href').startsWith('#')) {
      section = document.querySelector(link.getAttribute('href'));
    }
    let onclick = link.getAttribute('onclick');
    if (section || onclick) {
      button.classList.add('--show');
    }
  })
}, false);